import { RiDeleteBin5Line } from "react-icons/ri"
import { MdUpdate } from "react-icons/md"
import { BsEyeFill } from "react-icons/bs"

const Row = ({employee, setDroppedEmployee, setEmployeeToView}) => {
  return (
    <tr className="bg-white border-b dark:bg-gray-50 dark:border-gray-300 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-100">
    <th scope="row" className="flex items-center px-6 py-2 font-medium text-gray-900  whitespace-nowrap">
     <img className="w-10 h-10 rounded-full mr-2 object-cover" src={employee.imageUrl ? employee.imageUrl : 'https://www.seekpng.com/png/detail/428-4287240_no-avatar-user-circle-icon-png.png'} alt="" />   {employee.name}
    </th>
    <td className="px-6 py-2">
        {employee.email}
    </td>
    <td className="px-6 py-2">
        {employee.phone}
    </td>
    <td className="px-6 py-2">
      <div className="flex items-center space-x-3">
       <MdUpdate className='text-2xl cursor-pointer rounded-full hover:shadow hover:text-green-600 hover:scale-150 transition-all duration-200'/>
       <RiDeleteBin5Line className='text-2xl cursor-pointer rounded-full hover:shadow hover:text-red-500 hover:scale-150 transition-all duration-200' onClick={()=> setDroppedEmployee(employee)}/> 
       <BsEyeFill onClick={()=> setEmployeeToView(employee)} className='text-2xl cursor-pointer rounded-full hover:shadow hover:scale-150 transition-all duration-200 hover:text-blue-600'/>
      </div>
    </td>
</tr>

  )
}

export default Row